import React, { Component } from 'react';

import RTree from './RTree';

export default class extends Component {
    constructor(props) {
        super(props);
        this.viewType =  this.props.viewType;
        this.targetId = this.props.targetId;
        this.masterResultId =  this.props.masterResultId;
        this.v =  this.props.v;
        this.state = {
            data: [],
            treeUpdateTime: Date.now()
        }
    }

    componentWillReceiveProps(nextProps) {
        const targetId = nextProps.targetId;
        const masterResultId = nextProps.masterResultId;
        const viewType = nextProps.viewType;
        const v = nextProps.v;
        if(this.viewType !== viewType && viewType || this.targetId !== targetId && targetId || this.masterResultId !== masterResultId && masterResultId  || this.v !== v && v ) {
            this.viewType = viewType;
            this.targetId = targetId;
            this.masterResultId =  masterResultId;
            this.v =  v;
            this.querySearch();
        }
    }

    componentDidMount() {
        this.querySearch();

        if(typeof this.props.api === 'function') {
            this.props.api(this);
        }
    }

    querySearch() {
        return this.props.service.querySearchByReview({
            targetId: this.targetId,
            viewType: this.viewType,
            id: this.masterResultId
        }).then(response => {
            this.setState({
                treeUpdateTime: Date.now(),
                data: response.data
            });
        });
    }
    
    onSelect(selectedKeys, label, disabled, status) {
        //this.props.handleChange(selectedKeys[0]);
        if(typeof this.props.onSelect === 'function') {
            this.props.onSelect(selectedKeys[0],disabled,status);
        }
    }

    render() {
        const { data } = this.state;
        return (
            <div className="app-ztree">
                <div className="apps-tree">
                    <div className="apps-tree-container">
                        <RTree treeUpdateTime={this.state.treeUpdateTime} onSelect={this.onSelect.bind(this)} data={data} {...this.props} />
                    </div>
                </div>
                
            </div>
        );
    }
}
